import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3a0e2afe"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"
import style0 from "./detail.vue?vue&type=style&index=0&id=3a0e2afe&prod&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=3a0e2afe&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports